import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-center mt-20"
}
const _hoisted_2 = { class: "justify-center w-1/2 flex flex-col" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "w-full mx-auto rounded-lg border-2 border-sky-blue p-5 shadow-lg" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-2 text-lg font-medium" }, [
    /*#__PURE__*/_createTextVNode("$MOUNT has been deprecated, kindly unstake on this website and restake at "),
    /*#__PURE__*/_createElementVNode("a", {
      className: "text-blue-700",
      target: "_blank",
      href: "https://stake-mtm.metamounts.io"
    }, "stake-mtm.metamounts.io")
  ])
], -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mx-auto text-center mt-20 mb-5 w-3/4" }, " Staking account associated to your wallet is not found... Create an account to start staking! ", -1)
const _hoisted_8 = { class: "w-full text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_ConfigPane = _resolveComponent("ConfigPane")!
  const _component_FarmerDisplay = _resolveComponent("FarmerDisplay")!
  const _component_Vault = _resolveComponent("Vault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loading, {
      active: _ctx.isLoading,
      "is-full-page": _ctx.fullPage,
      loader: _ctx.loader
    }, null, 8, ["active", "is-full-page", "loader"]),
    (!_ctx.wallet)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_ConfigPane)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.farmerAcc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_FarmerDisplay, {
                  key: _ctx.farmerAcc,
                  farm: _ctx.farm,
                  farmAcc: _ctx.farmAcc,
                  farmer: _ctx.farmer,
                  farmerAcc: _ctx.farmerAcc,
                  class: "mb-10",
                  onRefreshFarmer: _ctx.handleRefreshFarmer
                }, null, 8, ["farm", "farmAcc", "farmer", "farmerAcc", "onRefreshFarmer"]),
                _createVNode(_component_Vault, {
                  key: _ctx.farmerAcc,
                  class: "mb-10",
                  vault: _ctx.farmerAcc.vault.toBase58(),
                  farmerAcc: _ctx.farmerAcc,
                  farmerState: _ctx.farmerState,
                  onSelectedWalletNft: _ctx.handleNewSelectedNFT,
                  onFlashDepositWalletNft: _ctx.flashDepositSelectedNFT,
                  onFetchFarm: _ctx.fetchFarn,
                  onFetchFarmer: _ctx.fetchFarmer
                }, {
                  default: _withCtx(() => [
                    ((((_ctx.farmerAcc.rewardA.accruedReward - _ctx.farmerAcc.rewardA.paidOutReward) / (1000000000)) + (parseInt(_ctx.farmerAcc.gemsStaked) * (Math.round(_ctx.currentTS/1000) - _ctx.farmerAcc.rewardA.fixedRate.lastUpdatedTs) * 12 / 86400)) > 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "nes-btn is-warning",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.claim && _ctx.claim(...args)))
                        }, " Claim $MOUNT "))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["vault", "farmerAcc", "farmerState", "onSelectedWalletNft", "onFlashDepositWalletNft", "onFetchFarm", "onFetchFarmer"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    class: "nes-btn is-primary",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.initFarmer && _ctx.initFarmer(...args)))
                  }, " Create Account ")
                ])
              ]))
        ]))
  ], 64))
}